import React from "react";
import Banner from "../components/about-her/banner";
import Content from "../components/about-her/contents";
import Footer from "../components/about-her/footer";

function AboutHer() {
  return (
    <>
      <Banner />
      <Content />
      <Footer />
    </>
  );
}

export default AboutHer;
